<template>
	<!--报告解读-->
	<!-- v-if="detail.autoReadReport == 1" -->
	<base-card
		v-if="detail.autoReadReport == 1"
		class="mt-28"
		title="报告解读"
		custom-class="export_parse_box"
	>
		<div class="export_parse">
			<p class="export_parse_inner">
				订单完成后，为您免费申请医生的报告解读服务，为您的健康提供额外关怀。
			</p>
			<div class="export_parse_checkbox">
				<van-checkbox
					:value="checkedExportParse"
					@click="updateAutoReadReport"
				></van-checkbox>
			</div>
		</div>
	</base-card>
</template>

<script>
	export default {
	  props: {
	    detail: {
	       type: Object,
	       default: () => ({})
	    },
	    disabled: {
	       type: Boolean,
	       default: false
	    }
	  },
	  data: () => ({
	    checkedExportParse: true
	  }),
	  methods: {
	    // 更新是否需要报告解读的需求
	    async updateAutoReadReport () {
	      if (this.disabled) return;
	      const res = await this.$api.order.autoReadReport({ id: this.$route.params.id});
	      if (!res.code) {
	        this.checkedExportParse = !this.checkedExportParse
	      }
	    },
	  }
	}
</script>

<style scoped lang="less">

	.export_parse_box {
	  background-image: linear-gradient(to bottom, #D8F9FA, #fff 30%);
	}
	.export_parse {
	  margin-top: -20px;
	  padding-right: 100px;
	  position: relative;
	  &_inner {
	    font-family: PingFangSC-Regular;
	    font-size: 28px;
	    font-weight: normal;
	    line-height: 40px;
	    color: #8F959E;
	  }
	  &_checkbox {
	    position: absolute;
	    right: 0;
	    top: 0;
	  }
	}
</style>
